import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { fetchFolderUrl } from 'hb-react/frontoffice/apps/MediaCenter/utils/mediaCenterUrls';
import {
  FOLDER_NOT_FOUND,
  MEDIA_CENTER_QUERY_KEYS,
} from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useFolder = ({ folderUuid, topicId }) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [MEDIA_CENTER_QUERY_KEYS.folder, folderUuid],
    queryFn: () => getFolder(folderUuid, topicId),
    enabled: !!folderUuid,
  });

  const result = useMemo(
    () => ({
      currentFolder: data?.folder,
      error: error ? FOLDER_NOT_FOUND : '',
      isLoading,
    }),
    [data?.folder, error, isLoading],
  );

  return result;
};

const getFolder = (folderUuid, topicId) =>
  axios.get(fetchFolderUrl(folderUuid, topicId)).then((res) => res.data);
